import React from 'react'
import * as PropTypes from 'prop-types'
import styled from 'styled-components'

const Content = ({ children, ...props }) => {
  return <StyledContent {...props}>{children}</StyledContent>
}

Content.propTypes = {
  children: PropTypes.node.isRequired,
}

const StyledContent = styled.div`
  margin: auto;
  padding: ${props => props.theme.size.l} 0;
  width: 85%;

  @media ${props => props.theme.mediaQuery.largeUp} {
    padding: ${props => props.theme.size.xxl} 0;
    width: 75%;
  }
`

export default Content
